import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AppLogoImage from 'assets/images/AppLogo.png';
import { sendOtpApi } from 'app/api/onboarding';
import PageLoader from 'app/components/PageLoader';
import NumberInput from 'app/components/UI/NumberInput';
import Button from 'app/components/button';
import AltTag from 'app/constants/alt-tag';
import './index.scss';

const MobileOtpLogin = () => {
  const [pageLoading, setPageLoading] = useState(false);
  const navigate = useNavigate();
  const [mobileNumber, setMobileNumber] = useState(null);
  const [error, setError] = useState('');

  const handleSendOtp = async (event) => {
    event?.preventDefault();
    let num = mobileNumber && parseInt(mobileNumber);
    if (mobileNumber?.length !== 10) {
      setError('Mobile number must be exactly 10 digits');
      return;
    }
    if (error === 'Login user failed!' || error === 'User not exist !') {
      return;
    }
    try {
      setPageLoading(true)
      const response = await sendOtpApi({ "phoneNumber": num });
      setPageLoading(false)
      if (response?.responseCode === 200) {
        setPageLoading(false)
        navigate(`/otpscreen`, {
          state: { num: num },
        });
      } else {
        setError(response?.response?.message ? response?.response?.message : 'Failed to send OTP. Please try again.');
      }
    } catch (err) {
      setError('An error occurred. Please try again.');
    }
  };

  const handleNumber = (val) => {
    setMobileNumber(val);
    setError('');

    const regexPattern = /^[6-9]\d{9}$/;
    if ((val.length > 10 && !regexPattern.test(val))) {

      setError('Mobile number must be exactly 10 digits');

    }
  };

  return (
    <div className='app'>
      <div className='loginWrapper'>
        <div className='loginContainer'>
          <div className='logoContainer'>
            <img src={AppLogoImage} alt={AltTag.AppLogo} className='appLogo' />
          </div>
          <div className='formContainer'>
            <form noValidate onSubmit={handleSendOtp}>
              <NumberInput

                name='mobileNumber'
                label='Mobile Number'
                errorText={error}
                value={mobileNumber}
                onChange={(e) => handleNumber(e.target.value)}
                placeholder="Enter your mobile number"
                aria-label="Mobile Number"
                aria-required="true"
                aria-invalid={!!error}
              />
              <Button
                type='submit' name={'Send OTP'}
                className="mt-2 form-control text-center text-white"
              />
            </form>
          </div>
        </div>
      </div>
      <PageLoader pageLoading={pageLoading} />
    </div>
  );
};

export default MobileOtpLogin;
